<!--
발송작업 > 경고
-->
<template>
    <div class="uk-flex uk-flex-center">
        <div class="warning" v-if="diffProdName">
            <div class="title">
                <i class="material-icons">warning</i>
                <span class="uk-text-middle">WARNING</span>
            </div>
            재고상품과 배송상품의 상품명이 일치하지 않습니다
        </div>

        <div class="warning" v-if="diffAmount">
            <div class="title">
                <i class="material-icons">warning</i>
                <span class="uk-text-middle">WARNING</span>
            </div>
            재고상품과 배송상품의 수량이 일치하지 않습니다
        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },
        props: {
            // 배송상품
            shipProd: Object,

            // 재고상품
            stockProd: Object,

            // 재고발송수량
            stockOutAmount: Number,
        },
        data: function () {
            return {
            };
        },
        computed: {
            /**
             * 재고상품과 배송상품간의 상품명이 일치하지 않는 경고출력 여부
             * @return bool
             */
            diffProdName() {
                return false; // 더이상 사용안함.
                /*
                return this.stockProd
                    && this.shipProd
                    && this.stockProd.name !== this.shipProd.name;

                 */
            },

            /**
             * 재고상품 발송수량과 배송상품간의 수량이 일치하지 않는 경고출력 여부
             * @return bool
             */
            diffAmount() {
                return this.stockProd
                    && this.shipProd
                    && this.stockOutAmount !== this.shipProd.amount;
            },
        },
        methods: {

        },
    }
</script>

<style lang="scss" scoped>
    .warning {
        background-color: #fff;
        border: 1px solid #ee395b;
        padding: 1rem;
        text-align: center;
        font-size: 1.25rem;
        color: #000;


        .title {
            display: inline-block;
            color: #ee395b;
            margin-right: 2rem;
            .material-icons {
                font-size: 1.75rem;
            }
        }
    }
</style>